export const isAuthenticationRejection = (error) =>
  [401, 403].includes(error?.response?.status);
